import { PlayoffDoubleTypes } from '../../../packages/constants/tennis';

export const isKnouckoutGameDoubles = (type?: string): boolean => {
  switch (type) {
    case PlayoffDoubleTypes.MALE_DOUBLES: {
      return true;
    }
    case PlayoffDoubleTypes.FEMALE_DOUBLES: {
      return true;
    }
    case PlayoffDoubleTypes.MIXED_DOUBLES: {
      return true;
    }
    default: {
      return false;
    }
  }
};
